import { usePathname, useRouter } from 'next/navigation';
import { onStart } from '@/utils/helpers/navigation';

const useCustomRouter = () => {
	const defaultRouter = useRouter();
	const pathname = usePathname();

	const push = (path: string) => {
		onStart(path, pathname);
		const splitPath = pathname?.split('/');

		defaultRouter.push(`/${splitPath[1]}/${splitPath[2]}${path}`);
	};

	return {
		push,
	};
};

export { useCustomRouter };
